type Bubble = {
  top: string;
  left: string;
  size: number;
  delay: string;
  opacity: number;
};

const BUBBLES: Bubble[] = [
  { top: '8%', left: '6%', size: 70, delay: '0s', opacity: 0.5 },
  { top: '22%', left: '88%', size: 46, delay: '1.2s', opacity: 0.45 },
  { top: '62%', left: '3%', size: 34, delay: '0.6s', opacity: 0.4 },
  { top: '78%', left: '80%', size: 90, delay: '2s', opacity: 0.35 },
  { top: '40%', left: '48%', size: 26, delay: '1.6s', opacity: 0.3 },
  { top: '12%', left: '62%', size: 40, delay: '2.4s', opacity: 0.4 },
];

export default function Bubbles({ className = '' }: { className?: string }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="animate-bubble absolute rounded-full border border-secondary-300/60 bg-secondary-200/40"
          style={{
            top: b.top,
            left: b.left,
            width: `${b.size}px`,
            height: `${b.size}px`,
            animationDelay: b.delay,
            opacity: b.opacity,
          }}
        />
      ))}
    </div>
  );
}